export default __webpack_public_path__ + "static/media/twitterHover.46892fbd.svg";